<template>
  <div background="#ffffff" class="user-center__notice-container collect-product-list-container">
    <div class="met-tip-c">
      <h3>关于项目清单使用方法</h3>
      <p>1、可以将在平台「产品」板块收藏的产品，自动整理为excel表格，并支持下载到本地。</p>
      <p>2、支持根据不同项目，新建不同项目文件夹，方便管理。</p>
      <p>3、首次使用需要先新建一个项目文件夹。</p>
      <p class="line-c"></p>
    </div>
    <div class="header__bts">
      <el-button class="black" @click="addProject">新建项目文件夹</el-button>
      <!--<el-button class="yellow" @click="exportData">导出Excel材料清单</el-button>-->
    </div>
    <div class="notice__main-body" v-if="lists">
      <div
        class="main-body__item"
        v-for="list in lists"
        :key="list.id"
        :data-type="list.type"
        :data-targetid="list.target_id"
        :data-id="list.id"
      >
        <div class="item__wrapper">
          <div class="item__icon">
            <img :src="list.title_picture_url | parseImage" alt width="90" height="90" />
          </div>
          <div class="item__info">
            <p class="info__createds">
              {{list.name}}
              <i class="el-icon-edit" @click="addName(list)"></i>
            </p>
            <p class="info__texts">收藏项目数量：{{list.num}}</p>
            <!-- <p v-if="list.id!==10000000"> -->
            <!-- <router-link class="el-button yellow" to="/my/exceldata">导出Excel材料清单</router-link> -->
            <el-button class="yellow" @click="exportData(list)">导出Excel材料清单</el-button>
            <!-- <el-button  class="yellow" :data-projectid="list.id" @click="addProjects" >添加至项目</el-button> -->
            <el-button class="black" :data-projectid="list.id" @click="delData">删除</el-button>
            <!-- <el-button  class="yellow" :data-projectid="list.id" @click="goProject" >进入项目文件夹</el-button> -->
            <!-- </p> -->
            <!-- <p v-else>
                 <el-button  class="yellow" :data-projectid="list.id" @click="goProject" >进入项目文件夹</el-button>
            </p>-->
          </div>
        </div>
      </div>
    </div>
    <empty hint="没有找到相关信息" v-else></empty>
  </div>
</template>

<script>
import { scrollToUp } from "@/assets/utils/common";
import {
  materialClist,
  delfolder,
  addCollectionFolder,
  upProjectFolder
} from "@/api/user";
import Empty from "@/pages/common/empty.vue";
import { userDel, userAddProject } from "@/api/common";
import { mapState } from "vuex";

export default {
  components: {
    Empty
  },
  data() {
    return {
      lists: null,
      requesting: false
    };
  },
  computed: {
    ...mapState("user", {
      userInfo: state => state.info
    })
  },
  watch: {
    $route: {
      handler: "init",
      immediate: true
    }
  },
  methods: {
    async init() {
      // 获取数据
      this.$store.commit("openLoading");
      const res = await materialClist({
        page: this.page,
        page_size: this.pageSize
      });
      const { data } = res;
      this.lists = data.list.length === 0 ? null : data.list;
      this.$emit('counts', data.list.length);
      scrollToUp();
      this.$store.commit("closeLoading");
    },

    addProject() {
      this.$router.push({
        path: `/collect/addproject/${this.$route.params.id}`
      });
    },
    goProject(e) {
      const data = e.currentTarget.dataset;
      this.$router.push({
        path: `/collect/folderlist/${data.projectid}`
      });
    },
    gourl() {
      this.$router.push({
        path: "/my/collects/products/0"
      });
    },
    addProjects(e) {
      const datas = e.currentTarget.dataset;
      const that = this;
      console.log(this.$route.params.id);
      if (this.$route.params.id == 0) {
        that.$message({
          type: "error",
          message: "请在「产品」板块进行收藏并添加至项目！",
          duration: 3000
        });
        return;
      }

      userAddProject(
        "确定把收藏产品添加至该项目中？",
        () =>
          addCollectionFolder({
            id: that.$route.params.id,
            pid: `${datas.projectid}`
          }),
        () => {
          that.gourl();
        }
      );
    },
    delData(e) {
      const datass = e.currentTarget.dataset;
      const id = `${datass.projectid}`;
      const that = this;
      userDel(
        "确定删除该项目文件夹？",
        () => delfolder({ id }),
        () => {
          that.lists = that.lists.filter(
            lists => Number(lists.id) !== Number(id)
          );
        }
      );
    },
    exportData(item) {
      this.$router.push({
        path: "/my/exceldata",
        query: {
          name: item.name,
          id: item.id
        }
      });
    },
    async addName(item) {
      let that = this;
      this.$prompt("项目文件夹名称", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消"
      }).then(({ value }) => {
        let params = {
          id: item.id,
          name: value
        };
        upProjectFolder(params).then(res => {
          that.init();
          this.$message({
            type: "success",
            message: "添加成功"
          });
        });
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.collect-product-list-container {
  .el-icon-edit {
    margin-left: 20px;
    cursor: pointer;
  }
  .met-tip-c {
    position: relative;
    h3 {
      line-height: 30px;
      padding-left: 30px;
    }
    p {
      line-height: 30px;
      padding-left: 30px;
    }
    .line-c {
      height: 2px;
      width: 100%;
      background: rgba(0,0,0,0.1);
      margin: 8px auto 20px;
      width: calc(100% + 40px);
      margin-left: -20px;
    }
  }
}
.el-button {
  display: inline-block;
  line-height: 1;
  white-space: nowrap;
  cursor: pointer;
  background: #fff;
  border: 1px solid #dcdfe6;
  color: #606266;
  -webkit-appearance: none;
  text-align: center;
  box-sizing: border-box;
  outline: 0;
  margin: 0;
  transition: 0.1s;
  font-weight: 500;
  padding: 5px 8px;
  font-size: 12px;
  border-radius: 4px;
}
.red {
  background-color: #ff0000;
  color: #ffffff;
}
.black {
  background-color: #000;
  color: #ffffff;
}
.yellow {
  background-color: #fabe00;
  color: #ffffff;
}
.header__bts {
  margin-bottom: 10px;
  margin-left: 30px;
  .bt-item {
    width: px2vw(97);
    height: px2vw(35);
    background-color: #000;
    border-radius: 4px;
    line-height: px2vw(35);
    // @include font-size-14;
    color: #fff;
    text-align: center;
    cursor: pointer;
  }
}
.info__createds {
  font-size: 16px;
  line-height: 34px;
}
.info__texts {
  font-size: 12px;
  line-height: 32px;
}
</style>
